import appContext from 'legacy/appcontext';
import AccountModel from '@old/modules/accounts/models/account';
import ProjectModel from '@old/modules/projects/models/project';
import BidmanagerGroupModel from '@old/modules/optimization/bidmanager/models/basegroup';
import CurrencyCollection from '@old/modules/currency/collections/currency';
import PlacementModel from '@old/modules/placements/models/placement';
import ConnectionModel from '@old/modules/connectionsOld/models/connection';
import OrderModel from '@old/modules/common/orders/models/order';
import CurrencyModel from '@old/modules/currency/models/currency';
import CurrentUserModel from '@old/modules/common/models/currentuser';
import UserRoleModel from '@old/modules/common/models/currentuserrole';
import UserPermissionsCollection from '@old/modules/common/collections/currentuserpermissions';
import ContractModel from '@old/modules/contracts/models/contract';
import TimezoneCollection from '@old/modules/timezones/collections/timezone';
import TimezoneModel from '@old/modules/timezones/models/timezone';
import WAProvidersCollection from '@old/modules/webanalytics/collections/provider';
import BaseModel from '@old/modules/common/models/base';
import ChannelsCollection from '@old/modules/channels/collections/channel';
import ChannelsModel from '@old/modules/channels/models/channel';
import RolesCollection from '@old/modules/common/collections/role';
import store from 'store';
import translation from 'translation';
import {fetchDataForRoutePrams} from 'router/utils/fetchStoreData';
import objectKeysToCamel from 'utils/object/objectKeysToCamel';
import router from 'router';
import tracker from 'tracking';
import {userService} from 'services';
import scheduleOnboarding from 'onboarding/scheduleOnboarding';

// this is hack to patch appContext without dealing with circular imports
function fillModel (model, storeValue) {
    if (!storeValue) {
        return model;
    }
    Object.keys(storeValue).map(key => {
        model.set(key, storeValue[key]);
    });

    return model;
}

function fillCollection (collection, ModelClass, storeValue) {
    storeValue.forEach(val => {
        const model = new ModelClass();
        fillModel(model, val);
        collection.push(model);
    });
    return collection;
}

// todo: tmp hack
appContext.tracker = tracker;

appContext.basePath = function () {
    return store.getters['common/basePath'];
};

appContext.basePath = function () {
    return store.getters['common/basePath'];
};

appContext.fetchAccount = async function (accountId) {
    return store.dispatch('accounts/SET_CURRENT_ACCOUNT_ID', accountId);
};

appContext.userNotes = function () {
    console.error('User notes undefined');
};

appContext.releaseNotes = function () {
    console.error('Release notes undefined');
};

appContext.requestParams = function () {
    return router.currentRoute.query;
};

appContext.routeName = function () {
    return router.currentRoute.name;
};

appContext.prevRoute = function () {
    return store.getters['routing/prevRoute'];
};

appContext.isAori = function () {
    return store.getters['common/isAori'];
};

appContext.fetch = function (args) {
    return fetchDataForRoutePrams(objectKeysToCamel(args));
};

appContext.mccNestingLevel = function () {
    return store.getters['common/mccNestingLevel'];
};

appContext.roles = function () {
    return fillCollection(
        new RolesCollection(),
        BaseModel,
        store.getters['roles/rolesList']
    );
};

appContext.fetchUser = async function () {
    const user = await userService.getCurrentUser();
    await store.dispatch('user/SET_USER', user);
};

appContext.setAuthToken = function (token, {path, expires} = {}) {
    store.dispatch('common/SET_AUTH_TOKEN', {token, path, expires});
};

appContext.user = function () {
    return fillModel(
        new CurrentUserModel(),
        store.getters['user/currentUser']
    );
};

appContext.userId = function () {
    return store.getters['user/currentUser'].id;
};

appContext.can_user = function (permission) {
    return store.getters['user/canUser'](permission);
};

appContext.role = function () {
    return fillModel(
        new UserRoleModel(),
        store.getters['user/userRole']
    );
};

appContext.permissions = function () {
    return fillCollection(
        new UserPermissionsCollection(),
        BaseModel,
        store.getters['user/permissions'].items
    );
};

appContext.account = function () {
    return fillModel(
        new AccountModel(),
        store.getters['accounts/currentAccount']
    );
};

appContext.accountId = function () {
    return store.getters['accounts/currentAccountId'];
};

appContext.project = function () {
    return fillModel(
        new ProjectModel(),
        store.getters['projects/currentProject']
    );
};

appContext.bidManagerGroup = function () {
    return fillModel(
        new BidmanagerGroupModel(),
        store.getters['bidmanager/currentBidmanagerGroup']
    );
};

appContext.placement = function () {
    return fillModel(
        new PlacementModel(),
        store.getters['placements/currentPlacement']
    );
};

appContext.connection = function () {
    return fillModel(
        new ConnectionModel(),
        store.getters['connections/currentConnection']
    );
};

appContext.order = function () {
    return fillModel(
        new OrderModel(),
        store.getters['orders_old/currentOrder']
    );
};

appContext.currencies = function () {
    const currencyCollection = new CurrencyCollection();
    fillCollection(
        currencyCollection,
        CurrencyModel,
        store.getters['enums/currencies']
    );

    return currencyCollection;
};

appContext.timezones = function () {
    return fillCollection(
        new TimezoneCollection(),
        TimezoneModel,
        store.getters['enums/timezones']
    );
};

appContext.channels = function () {
    return fillCollection(
        new ChannelsCollection(),
        ChannelsModel,
        store.getters['channels/channels']
    );
};

appContext.waProviders = function () {
    return fillCollection(
        new WAProvidersCollection(),
        BaseModel,
        store.getters['channels/providers']
    );
};

appContext.contract = function () {
    return fillModel(
        new ContractModel(),
        store.getters['contract/currentContract']
    );
};

appContext.showOnboarding = function (params) {
    const {id: onboardingId, ...onboardingOptions} = params;
    return scheduleOnboarding(onboardingId, onboardingOptions);
};

appContext.tr = translation.tr.bind(translation);
appContext.trc = translation.trc.bind(translation);
appContext.ngettext = translation.ngettext.bind(translation);
appContext.helpFor = translation.helpFor.bind(translation);
appContext.dateFormatter = function () {
    return translation.dateFormatter;
};
appContext.numeralDelimeters = function () {
    return translation.numeralDelimeters;
};

appContext.config = function (name) {
    if (name === undefined) {
        return store.getters['common/appConfig'];
    }
    return store.getters['common/appConfig'][name];
};
